export default `
  mutation adminUpdateOrganisationAccount(
    $id: String!
    $orgType: String
    $pocName: String
    $pocEmail: String
    $licenseStartDate: String
    $licenseEndDate: String
    $licensedSeats: Int
    $accountStatus: String
    $accountNotes: String
  ) {
    adminUpdateOrganisationAccount(
      id: $id
      orgType: $orgType
      pocName: $pocName
      pocEmail: $pocEmail
      licenseStartDate: $licenseStartDate
      licenseEndDate: $licenseEndDate
      licensedSeats: $licensedSeats
      accountStatus: $accountStatus
      accountNotes: $accountNotes
    ) {
      id
      orgType
      pocName
      pocEmail
      licenseStartDate
      licenseEndDate
      licensedSeats
      accountStatus
      accountNotes
      updatedAt
    }
  }
`
